import {
  QualityRegimeOptions,
  correctionReasonOptions,
  gldAirPressureCompensationTypeOptions,
  gldEvaluationProcedureOptions,
  gldMeasurementInstrumentOptions,
  gldObservationTypeOptions,
  gldProcessReferenceOptions,
  gldStatusQualityControlOptions,
  qualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchemaField, getEnumNamesAndDisabled } from "@/libs/brostar-form";

import { ExplainTimeseriesFile } from "../components/explain-timeseries-file";

/**
 * UI Schema library for GLD forms with reusable field configurations.
 * Returns a flat object with all field UI schema configurations.
 */
export const createGldUiSchemaLibrary = (qualityRegime: QualityRegimeOptions | undefined) =>
  ({
    // Shared metadata fields
    projectNumber: {},
    broId: {},
    qualityRegime: getEnumNamesAndDisabled(qualityRegimeOptions, qualityRegime),
    deliveryAccountableParty: {
      "ui:widget": "OrganisationSelect",
    },
    correctionReason: getEnumNamesAndDisabled(correctionReasonOptions, qualityRegime),

    // GLD Start Registration fields
    objectIdAccountableParty: {},
    gmwBroId: {},
    tubeNumber: {},
    groundwaterMonitoringNets: {
      "ui:widget": "GmnSelectTable",
      items: {},
    },

    // GLD Addition fields
    observationId: {},
    processReference: getEnumNamesAndDisabled(gldProcessReferenceOptions, qualityRegime),
    evaluationProcedure: getEnumNamesAndDisabled(gldEvaluationProcedureOptions, qualityRegime),
    measurementInstrumentType: getEnumNamesAndDisabled(
      gldMeasurementInstrumentOptions,
      qualityRegime
    ),
    airPressureCompensationType: getEnumNamesAndDisabled(
      gldAirPressureCompensationTypeOptions,
      qualityRegime
    ),
    investigatorKvk: {},
    observationType: getEnumNamesAndDisabled(gldObservationTypeOptions, qualityRegime),
    statusQualityControl: getEnumNamesAndDisabled(gldStatusQualityControlOptions, qualityRegime),
    timeseriesFile: {
      "ui:widget": "FileWidget",
      "ui:explanation": <ExplainTimeseriesFile />,
      "ui:options": {
        accept:
          ".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      },
    },
  } satisfies Record<string, BrostarUiSchemaField>);

export type GldUiSchemaLibrary = ReturnType<typeof createGldUiSchemaLibrary>;
